// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: producer/producer_spatial_layer_request.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "producer";

export interface ProducerSpatialLayerRequest {
  producerId: string;
  spatialLayer: number;
}

function createBaseProducerSpatialLayerRequest(): ProducerSpatialLayerRequest {
  return { producerId: "", spatialLayer: 0 };
}

export const ProducerSpatialLayerRequest: MessageFns<ProducerSpatialLayerRequest> = {
  encode(message: ProducerSpatialLayerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.producerId !== "") {
      writer.uint32(10).string(message.producerId);
    }
    if (message.spatialLayer !== 0) {
      writer.uint32(16).uint32(message.spatialLayer);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProducerSpatialLayerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProducerSpatialLayerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.producerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.spatialLayer = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProducerSpatialLayerRequest {
    return {
      producerId: isSet(object.producerId) ? globalThis.String(object.producerId) : "",
      spatialLayer: isSet(object.spatialLayer) ? globalThis.Number(object.spatialLayer) : 0,
    };
  },

  toJSON(message: ProducerSpatialLayerRequest): unknown {
    const obj: any = {};
    if (message.producerId !== "") {
      obj.producerId = message.producerId;
    }
    if (message.spatialLayer !== 0) {
      obj.spatialLayer = Math.round(message.spatialLayer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProducerSpatialLayerRequest>, I>>(base?: I): ProducerSpatialLayerRequest {
    return ProducerSpatialLayerRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProducerSpatialLayerRequest>, I>>(object: I): ProducerSpatialLayerRequest {
    const message = createBaseProducerSpatialLayerRequest();
    message.producerId = object.producerId ?? "";
    message.spatialLayer = object.spatialLayer ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
